export const Config = {
    baseFolder: '',
    apiRoot: 'https://uosportal.normasoft.net/api/v1/',
    protectionOff: false
};
